module.exports = __webpack_public_path__ + "jm.svg?a7ca963e01f0017b53e1b3655361fa79";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/jm.svg
// module id = 1287
// module chunks = 27